"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.navItemToFunctionalityMapping = exports.navItemFunctionalityType = void 0;
const navItemFunctionalityType = exports.navItemFunctionalityType = {
  LINK: 1,
  LOGOUT: 2,
  SALE_FORCE: 3,
  CLICK_DROP_DOWN: 4,
  DROP_DOWN: 5,
  DISABLED_LINK: 6,
  LIVE_CHAT: 7,
  ACTIVITY_FEED: 8,
  COMPONENT: 9,
  CHANGE_PASSWORD: 10
};
const navItemToFunctionalityMapping = exports.navItemToFunctionalityMapping = {
  InternalLink: navItemFunctionalityType.LINK,
  ExternalLink: navItemFunctionalityType.LINK,
  Logout: navItemFunctionalityType.LOGOUT,
  ClickDropDown: navItemFunctionalityType.CLICK_DROP_DOWN,
  DropDown: navItemFunctionalityType.DROP_DOWN,
  LiveChat: navItemFunctionalityType.LIVE_CHAT,
  DisabledLink: navItemFunctionalityType.DISABLED_LINK,
  ActivityFeed: navItemFunctionalityType.ACTIVITY_FEED,
  Component: navItemFunctionalityType.COMPONENT,
  SalesForce: navItemFunctionalityType.SALE_FORCE,
  DropDownColumn: null,
  ChangePassword: navItemFunctionalityType.CHANGE_PASSWORD
};